<template>
  <div class="empadronamiento__intro__main">
    <div class="empadronamiento__intro__main__form" v-if="!loading">
      <div class="empadronamiento__intro__main__form__header">
        <p>{{ModelProcedure.UnitFullName}}</p>
      </div>
      <div class="empadronamiento__intro__main__form__container">
        <form @submit.prevent>
          <fieldset>
            <div class="empadronamiento__intro__main__form__container-header">
              <p style="text-transform:uppercase;">Domicilio legal ({{ModelProcedure.Titulars[titularIdx].Name}} {{ModelProcedure.Titulars[titularIdx].LastName}})</p>
            </div>

            <base-input 
              placeholder="Calle *" 
              v-model="ModelProcedure.Titulars[titularIdx].FormerAddresStreet"
              :invalid="$v.ModelProcedure.Titulars.$each[titularIdx].FormerAddresStreet.$invalid && submitted"
            />
            <base-input 
              type="number" 
              placeholder="Número *" 
              v-model="ModelProcedure.Titulars[titularIdx].FormerAddresNumber"
              :invalid="$v.ModelProcedure.Titulars.$each[titularIdx].FormerAddresNumber.$invalid && submitted"
            />
            <base-input 
              placeholder="Código Postal *" 
              v-model="ModelProcedure.Titulars[titularIdx].FormerAddresPostCode"
              :invalid="$v.ModelProcedure.Titulars.$each[titularIdx].FormerAddresPostCode.$invalid && submitted"
            />
            <base-input placeholder="Piso - Opcional" v-model="ModelProcedure.Titulars[titularIdx].FormerAddresFloor"/>
            <base-input placeholder="Departamento - Opcional" v-model="ModelProcedure.Titulars[titularIdx].FormerAddresDepartment"/>
            <base-input 
              placeholder="Localidad *" 
              v-model="ModelProcedure.Titulars[titularIdx].FormerAddresCity" 
              :invalid="$v.ModelProcedure.Titulars.$each[titularIdx].FormerAddresCity.$invalid && submitted"  
            />

            <base-select 
                placeholder="Provincia *" 
                v-model="ModelProcedure.Titulars[titularIdx].FormerAddresStateId" 
                :options="ListStates"
                :invalid="$v.ModelProcedure.Titulars.$each[titularIdx].FormerAddresStateId.$invalid && submitted" />

            <base-input 
              type="email" 
              placeholder="Email *" 
              v-model="ModelProcedure.Titulars[titularIdx].Email"
              :invalid="$v.ModelProcedure.Titulars.$each[titularIdx].Email.$invalid && submitted"  
            />
            <base-input 
              type="tel" 
              placeholder="Teléfono de contacto *" 
              v-model="ModelProcedure.Titulars[titularIdx].Phone"
              :invalid="$v.ModelProcedure.Titulars.$each[titularIdx].Phone.$invalid && submitted"  
            />
          </fieldset>
          <fieldset>
            <div class="empadronamiento__intro__main__form__container-header">
              <p style="text-transform:uppercase;">Datos laborales ({{ModelProcedure.Titulars[titularIdx].Name}} {{ModelProcedure.Titulars[titularIdx].LastName}})</p>
            </div>

            <base-input 
              placeholder="Profesión u ocupación *" 
              v-model="ModelProcedure.Titulars[titularIdx].WorkProfession"
              :invalid="$v.ModelProcedure.Titulars.$each[titularIdx].WorkProfession.$invalid && submitted"    
            />
            <base-input 
              placeholder="Rubro *" 
              v-model="ModelProcedure.Titulars[titularIdx].WorkCategory"
              :invalid="$v.ModelProcedure.Titulars.$each[titularIdx].WorkCategory.$invalid && submitted"    
            />
            <base-input 
              placeholder="Nombre de la empresa *" 
              v-model="ModelProcedure.Titulars[titularIdx].WorkCompanyName" 
              :invalid="$v.ModelProcedure.Titulars.$each[titularIdx].WorkCompanyName.$invalid && submitted"    
            />
            <base-input 
              placeholder="Localidad *"
              v-model="ModelProcedure.Titulars[titularIdx].WorkCity" 
              :invalid="$v.ModelProcedure.Titulars.$each[titularIdx].WorkCity.$invalid && submitted"    
            />
            <base-input 
              placeholder="Domicilio laboral *" 
              v-model="ModelProcedure.Titulars[titularIdx].WorkAddress" 
              :invalid="$v.ModelProcedure.Titulars.$each[titularIdx].WorkAddress.$invalid && submitted"  
            />
          </fieldset>
        </form>

        <div class="empadronamiento__intro__button">
          <button-link back>
            <p>Volver</p>
          </button-link>
          <button v-if="!loadingForm" class="active" @click="updateDomicilio()">Continuar</button>
          <button v-else disabled>Procesando ...</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { required, email, not } from 'vuelidate/lib/validators'

export default {
  data() {
    return {
      loading: true,
      titularIdx: 0,
      submitted: false,
      loadingForm: false
    }
  },
  computed: {
    ...mapState({
      ListStates: state => state.common.ListStates,
      ModelProcedure: state => state.manageVecino.ModelProcedure
    })
  },
  mounted() {
    const self = this
    if(!this.ModelProcedure.hasOwnProperty('UCode')) {
      this.$store.dispatch('getProcedure' , {
        ucode: this.$route.query.ucode
      }).then(() => {
        this.$store.dispatch('getSelectedCountryStates', 1)
        this.titularIdx = Number(this.$route.params.indexTitular)
        self.loading = false
      })
    } else {
      this.$store.dispatch('getSelectedCountryStates', 1)
      this.titularIdx = Number(this.$route.params.indexTitular)
      self.loading = false
    }
  },
  methods: {
    updateDomicilio() {
      const self = this
      self.submitted = true
      if (!self.isInvalidForm()) {
        self.loadingForm = true
        self.$store.dispatch("updateProcedure", {
          model: self.ModelProcedure
        }).then(() => {
          self.loadingForm = false
          if ((self.titularIdx + 1) === self.ModelProcedure.Titulars.length) {
            if (self.ModelProcedure.HasPhysicalTitulars) {
              self.$router.push(`/vecino/conyugePareja?ucode=${self.$route.query.ucode}`)
            } else {
              self.$router.push(`/vecino/referencia?ucode=${self.$route.query.ucode}`)
            }
          } else {
            self.$router.push(`/vecino/titularPropietario/${self.titularIdx + 1}?ucode=${self.$route.query.ucode}`)
          }
        })
      }
      else
      {
        var element = document.querySelector(".empadronamiento__intro__main__form__container-item .has-error");
        if(element != null)
          element.scrollIntoView({ behavior: 'smooth', block: 'nearest'}) 
      }
    },
    isInvalidForm() {
      return (
          this.$v.ModelProcedure.Titulars.$each[this.titularIdx].FormerAddresStreet.$invalid ||
          this.$v.ModelProcedure.Titulars.$each[this.titularIdx].FormerAddresNumber.$invalid ||
          this.$v.ModelProcedure.Titulars.$each[this.titularIdx].FormerAddresPostCode.$invalid ||
          this.$v.ModelProcedure.Titulars.$each[this.titularIdx].FormerAddresCity.$invalid ||
          this.$v.ModelProcedure.Titulars.$each[this.titularIdx].FormerAddresStateId.$invalid ||
          this.$v.ModelProcedure.Titulars.$each[this.titularIdx].Email.$invalid ||
          this.$v.ModelProcedure.Titulars.$each[this.titularIdx].Phone.$invalid ||
          this.$v.ModelProcedure.Titulars.$each[this.titularIdx].WorkProfession.$invalid ||
          this.$v.ModelProcedure.Titulars.$each[this.titularIdx].WorkCategory.$invalid ||
          this.$v.ModelProcedure.Titulars.$each[this.titularIdx].WorkCompanyName.$invalid ||
          this.$v.ModelProcedure.Titulars.$each[this.titularIdx].WorkCity.$invalid ||
          this.$v.ModelProcedure.Titulars.$each[this.titularIdx].WorkAddress.$invalid
      );
    }
  },
  validations: {
    ModelProcedure: {
      Titulars: {
        $each: {
          FormerAddresStreet: {
            required
          },
          FormerAddresNumber: {
            required
          },
          FormerAddresPostCode: {
            required
          },
          FormerAddresCity: {
            required
          },
          FormerAddresStateId: {
            required,
            not: not(model => model === 0)
          },
          Email: {
            required,
            email
          },
          Phone: {
            required
          },
          WorkProfession: {
            required
          },
          WorkCategory: {
            required
          },
          WorkCompanyName: {
            required
          },
          WorkCity: {
            required
          },
          WorkAddress: {
            required
          }
        }
      }
    }
  }
};
</script>

<style>
</style>